export default "__VITE_ASSET__DQZiqKAU__"